/* Cure — carrinho AJAX e seleção de variante */
(function () {
  var R = (window.Cure && window.Cure.routes) || {};

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  function refreshCount() {
    return fetch(R.cartJson, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); });
  }

  /* ── Página do produto ── */
  function initProduct(form) {
    var root = form.closest('[data-product]');
    var data = JSON.parse(root.querySelector('[data-variants]').textContent);
    var idInput = form.querySelector('[name="id"]');
    var button = form.querySelector('[data-add]');
    var flash = root.querySelector('[data-flash]');
    var priceEl = root.querySelector('[data-price]');
    var flashTimer;

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option]'), function (group) {
        var c = group.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function match(opts) {
      return data.variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
    }

    function update() {
      var v = match(selected());
      if (!v) { button.disabled = true; return; }
      idInput.value = v.id;
      button.disabled = !v.available;
      button.querySelector('[data-label]').textContent = v.available ? data.addLabel : data.soldOutLabel;
      if (priceEl) priceEl.innerHTML = v.priceHtml;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option] input')) update();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      button.disabled = true;
      fetch(R.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(refreshCount)
        .then(function () {
          if (flash) {
            flash.hidden = false;
            clearTimeout(flashTimer);
            flashTimer = setTimeout(function () { flash.hidden = true; }, 1500);
          }
        })
        .catch(function () { window.location.href = R.cart; })
        .then(function () { update(); });
    });

    /* galeria */
    var main = root.querySelector('[data-main-image]');
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.dataset.src;
        main.srcset = '';
        root.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });

    update();
  }

  /* ── Carrinho ── */
  function initCart(section) {
    var page = section.querySelector('[data-cart-page]');
    if (!page) return;
    var sectionId = section.dataset.sectionId;

    function rerender() {
      return fetch(R.cart + '?section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-cart-page]');
          if (next) page.innerHTML = next.innerHTML;
          page.classList.remove('is-loading');
          return refreshCount();
        });
    }

    function change(line, quantity) {
      page.classList.add('is-loading');
      return fetch(R.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(rerender).catch(function () { window.location.reload(); });
    }

    section.addEventListener('click', function (e) {
      var el = e.target.closest('[data-line]');
      if (!el) return;
      e.preventDefault();
      change(Number(el.dataset.line), Number(el.dataset.qty));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-form]').forEach(initProduct);
    document.querySelectorAll('[data-cart-section]').forEach(initCart);
  });
})();
